module.exports = __webpack_public_path__ + "resource/img/cims-logo.61aa2697.png";